export default __webpack_public_path__ + "static/media/16.9d4e38be.jpg";